const setCategoryList = (data) => ({ type: "SET_CATEGORY_LIST", data });
const setCategoryDetail = (data) => ({ type: "SET_CATEGORY_DETAIL", data });
const setCategoryPage = (data) => ({ type: "SET_CATEGORY_PAGE", data });

export const mutation = {
  setCategoryList,
  setCategoryDetail,
  setCategoryPage
};
